import { FaFilter, FaTimes } from 'react-icons/fa';

const DashboardFilters = ({ filters, onFilterChange, onClearFilters, filterConfig = [] }) => {
    if (!filterConfig || filterConfig.length === 0) return null;

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
            <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                        <FaFilter className="text-gray-500" />
                        <span className="font-medium text-gray-700">Filters:</span>
                    </div>
                    {filterConfig.map((filter) => (
                        <select
                            key={filter.key}
                            value={filters[filter.key] || 'all'}
                            onChange={(e) => onFilterChange({ ...filters, [filter.key]: e.target.value })}
                            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-600"
                        >
                            {filter.options.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    ))}
                </div>
                {onClearFilters && (
                    <button
                        onClick={onClearFilters}
                        className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-800 transition"
                    >
                        <FaTimes className="text-sm" />
                        <span>Clear Filters</span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default DashboardFilters;

